"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IERC165__factory", {
  enumerable: true,
  get: function get() {
    return _IERC165__factory.IERC165__factory;
  }
});

var _IERC165__factory = require("./IERC165__factory");